<ng-container *transloco="let t">
  <div class="account-form-container">
    <h2 class="heading-size-4">
      {{
        accountToEdit() ? t('oreg_account_edit') : t('oreg_account_add_account')
      }}
    </h2>
    <form [formGroup]="accountForm" (submit)="submitForm()">
      <div class="form-group">
        <lib-input-container
          [for]="'account-type'"
          [label]="t('oreg_account_account_type')"
          [required]="true"
        >
          <lib-vinnova-dropdown
            [id]="'account-type'"
            [placeholder]="t('oreg_account_choose_account_type')"
            [items]="accountTypeItems"
            [(ngModel)]="accountType"
            (ngModelChange)="onAccountTypeChange($event)"
            [ngModelOptions]="{ standalone: true }"
            [readonly]="accountReadonly()"
            [required]="true"
          ></lib-vinnova-dropdown>
        </lib-input-container>
      </div>
      @if (accountType === 'OTHER') {
        <div class="form-group">
          <lib-input-container
            [for]="'account-country'"
            [label]="t('oreg_account_add_country')"
            [required]="true"
          >
            <lib-vinnova-dropdown
              [id]="'account-country'"
              [placeholder]="t('oreg_account_add_country_placeholder')"
              [items]="countries"
              formControlName="country"
              [readonly]="accountReadonly()"
              [required]="true"
            ></lib-vinnova-dropdown>
          </lib-input-container>
        </div>
      }
      @if (accountForm.get('number').enabled) {
        <div class="form-group">
          <lib-input-container
            [for]="'account-number'"
            [label]="
              accountType === 'PlusGiro'
                ? t('oreg_account_PlusGiro_number')
                : accountType === 'BankGiro'
                  ? t('oreg_account_bank_transfer_number')
                  : t('oreg_account_account_number')
            "
            [required]="true"
            [errorText]="
              !(
                accountForm.get('number').touched &&
                accountForm.get('number').dirty &&
                accountForm.get('number').errors
              )
                ? undefined
                : accountForm.get('number').errors.required
                  ? t('oreg_account_please_add') +
                    (accountType === 'PlusGiro'
                      ? t('oreg_account_PlusGiro_number')
                      : accountType === 'BankGiro'
                        ? t('oreg_account_bank_transfer_number')
                        : t('oreg_account_account_number'))
                  : accountForm.get('number').errors.validBG
                    ? t('oreg_account_valid_bankgiro')
                    : accountForm.get('number').errors.validPG
                      ? t('oreg_account_valid_plusGiro')
                      : undefined
            "
            [warningText]="
              accountOtherCompany
                ? accountOtheraccountOtherCompanyName
                  ? t('oreg_account_account_already_added')
                  : t('oreg_account_account_number_already_exists')
                : undefined
            "
          >
            <input
              [readonly]="accountReadonly()"
              vinnova-text-input
              [id]="'account-number'"
              formControlName="number"
              [error]="
                accountForm.get('number').touched &&
                accountForm.get('number').dirty &&
                accountForm.get('number').errors
              "
              [warning]="!!existingAccountCompany"
              [inputType]="
                accountType === 'BankGiro'
                  ? InputType.Bankgiro
                  : accountType === 'PlusGiro'
                    ? InputType.PlusGiro
                    : undefined
              "
            />
          </lib-input-container>
        </div>
      }
      @if (accountForm.get('iban').enabled) {
        <div class="form-group">
          <lib-input-container
            [for]="'account-iban'"
            [label]="t('oreg_account_iban')"
            [required]="true"
            [questionMarkText]="t('oreg_account_iban_questionmark')"
            [errorText]="
              !(
                accountForm.get('iban').touched &&
                accountForm.get('iban').dirty &&
                accountForm.get('iban').errors
              )
                ? undefined
                : accountForm.get('iban').errors.required
                  ? t('oreg_account_add_iban')
                  : accountForm.get('iban').errors.validIban
                    ? t('oreg_account_add_valid_iban')
                    : undefined
            "
          >
            <input
              class="account-input-uppercase"
              [readonly]="accountReadonly()"
              vinnova-text-input
              [id]="'account-iban'"
              formControlName="iban"
              [error]="
                accountForm.get('iban').touched &&
                accountForm.get('iban').dirty &&
                accountForm.get('iban').errors
              "
            />
          </lib-input-container>
        </div>
      }
      @if (accountForm.get('fw').enabled) {
        <div class="form-group">
          <lib-input-container
            [for]="'account-fw'"
            [label]="t('oreg_account_fw')"
            [required]="true"
            [questionMarkText]="t('oreg_account_fw_questionmark')"
            [errorText]="
              !(
                accountForm.get('fw').touched &&
                accountForm.get('fw').dirty &&
                accountForm.get('fw').errors
              )
                ? undefined
                : accountForm.get('fw').errors.required
                  ? t('oreg_account_add_fw')
                  : accountForm.get('fw').errors.validFW
                    ? t('oreg_account_add_valid_fw')
                    : undefined
            "
          >
            <input
              class="account-input-uppercase"
              [readonly]="accountReadonly()"
              vinnova-text-input
              [id]="'account-fw'"
              formControlName="fw"
              [error]="
                accountForm.get('fw').touched &&
                accountForm.get('fw').dirty &&
                accountForm.get('fw').errors
              "
            />
          </lib-input-container>
        </div>
      }
      @if (accountForm.get('swift').enabled) {
        <div class="form-group">
          <lib-input-container
            [for]="'account-swift'"
            [label]="t('oreg_account_swift')"
            [required]="true"
            [questionMarkText]="t('oreg_account_swift_questionmark')"
            [errorText]="
              !(
                accountForm.get('swift').touched &&
                accountForm.get('swift').dirty &&
                accountForm.get('swift').errors
              )
                ? undefined
                : accountForm.get('swift').errors.required
                  ? t('oreg_account_add_swift')
                  : accountForm.get('swift').errors.validSwift
                    ? t('oreg_account_add_valid_swift')
                    : undefined
            "
          >
            <input
              class="account-input-uppercase"
              [readonly]="accountReadonly()"
              vinnova-text-input
              [id]="'account-swift'"
              formControlName="swift"
              [error]="
                accountForm.get('swift').touched &&
                accountForm.get('swift').dirty &&
                accountForm.get('swift').errors
              "
            />
          </lib-input-container>
        </div>
      }
      @if (accountForm.get('routingNumber').enabled) {
        <div class="form-group">
          <lib-input-container
            [for]="'account-routing'"
            [label]="t('oreg_account_routing_number')"
            [required]="true"
            [questionMarkText]="t('oreg_account_routing_number_questionmark')"
            [errorText]="
              !(
                accountForm.get('routingNumber').touched &&
                accountForm.get('routingNumber').dirty &&
                accountForm.get('routingNumber').errors
              )
                ? undefined
                : accountForm.get('routingNumber').errors.required
                  ? t('oreg_account_add_routing')
                  : accountForm.get('routingNumber').errors.validRouting
                    ? t('oreg_account_add_valid_routing')
                    : undefined
            "
          >
            <input
              class="account-input-uppercase"
              [readonly]="accountReadonly()"
              vinnova-text-input
              [id]="'account-routing'"
              formControlName="routingNumber"
              [error]="
                accountForm.get('routingNumber').touched &&
                accountForm.get('routingNumber').dirty &&
                accountForm.get('routingNumber').errors
              "
            />
          </lib-input-container>
        </div>
      }
      @if (accountForm.get('bsbCode').enabled) {
        <div class="form-group">
          <lib-input-container
            [for]="'account-bsb'"
            [label]="t('oreg_account_bsb_code')"
            [required]="true"
            [questionMarkText]="t('oreg_account_bsb_code_questionmark')"
            [errorText]="
              !(
                accountForm.get('bsbCode').touched &&
                accountForm.get('bsbCode').dirty &&
                accountForm.get('bsbCode').errors
              )
                ? undefined
                : accountForm.get('bsbCode').errors.required
                  ? t('oreg_account_add_bsb')
                  : accountForm.get('bsbCode').errors.validBSB
                    ? t('oreg_account_add_valid_bsb')
                    : undefined
            "
          >
            <input
              class="account-input-uppercase"
              [readonly]="accountReadonly()"
              vinnova-text-input
              [id]="'account-bsb'"
              formControlName="bsbCode"
              [error]="
                accountForm.get('bsbCode').touched &&
                accountForm.get('bsbCode').dirty &&
                accountForm.get('bsbCode').errors
              "
            />
          </lib-input-container>
        </div>
      }
      @if (accountSameCompany) {
        <div class="existing-account-container">
          <p>{{ t('oreg_account_account_number_exists_see_below') }}</p>
          <div class="account-info d-flex justify-content-between">
            <div>
              <span class="country">{{ t('oreg_account_sweden') }}</span>
              <span
                >{{ t('oreg_account_account_type') }}:
                {{
                  accountSameCompany.type === 'BankGiro'
                    ? t('oreg_account_bank_transfer_number')
                    : accountSameCompany.type === 'PlusGiro'
                      ? t('oreg_account_PlusGiro_number')
                      : undefined
                }}</span
              >
              <span
                >{{
                  accountSameCompany.type === 'PlusGiro'
                    ? t('oreg_account_PlusGiro_number')
                    : accountSameCompany.type === 'BankGiro'
                      ? t('oreg_account_bank_transfer_number')
                      : undefined
                }}: {{ accountSameCompany.number }}</span
              >
            </div>
            <button
              vinnova-button-primary
              type="button"
              (click)="accountSubmitted.emit(accountSameCompany)"
              class="align-self-start"
              [attr.aria-label]="t('oreg_account_select')"
            >
              {{ t('oreg_account_select') }}
            </button>
          </div>
        </div>
      }

      <div class="button-container">
        <button
          vinnova-button-secondary
          type="button"
          (click)="cancel.emit()"
          [attr.aria-label]="t('oreg_account_cancel')"
        >
          {{ t('oreg_account_cancel') }}
        </button>
        @if (!accountSameCompany && !accountOtherCompany) {
          <button
            vinnova-button-primary
            type="submit"
            [attr.aria-label]="
              accountToEdit()
                ? t('oreg_account_finished_btn')
                : t('oreg_account_btn_add')
            "
            [disabled]="addAccountDisabled"
          >
            {{
              accountToEdit()
                ? t('oreg_account_finished_btn')
                : t('oreg_account_btn_add')
            }}
          </button>
        }
        @if (accountOtherCompany) {
          <button
            type="submit"
            vinnova-button-text
            [disabled]="addAccountDisabled"
            [attr.aria-label]="
              accountToEdit()
                ? t('oreg_account_finished_btn')
                : t('oreg_account_btn_add')
            "
          >
            {{
              accountToEdit()
                ? t('oreg_account_finished_btn')
                : t('oreg_account_btn_add')
            }}
          </button>
        }
      </div>
    </form>
  </div>
</ng-container>
